/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheTopNavBar.vue?vue&type=template&id=0b7551c4&scoped=true"
import script from "./TheTopNavBar.ts?vue&type=script&lang=ts&external"
export * from "./TheTopNavBar.ts?vue&type=script&lang=ts&external"
import style0 from "./TheTopNavBar.vue?vue&type=style&index=0&id=0b7551c4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7551c4",
  null
  
)

export default component.exports